import React from 'react';
import Block from './Block';
import PillTag from './PillTag';
import Progress from '../primitives/Progress';
import Icon from '../primitives/Icon';

const ModelTrainingProgress = ({ blockData = {} }) => {
  const progress = Number(blockData.progress || 0);
  const stage = blockData.stage || 'Starting…';
  return (
    <Block
      icon="brain"
      title={blockData.title || 'Training a model'}
      badge={<PillTag tone="accent" dot>In progress</PillTag>}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
        <span style={{ fontSize: 13, color: 'var(--fg)' }}>{stage}</span>
        <div style={{ flex: 1 }} />
        <span style={{ fontSize: 12, color: 'var(--foreground)', fontVariantNumeric: 'tabular-nums' }}>
          {Math.round(progress)}%
        </span>
      </div>
      <Progress value={progress} />
      <div style={{ marginTop: 14, display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8 }}>
        {[
          { label: 'Cleaning data',        done: progress > 15 },
          { label: 'Splitting train/test', done: progress > 35 },
          { label: 'Fitting model',        done: progress > 80 },
        ].map((s, i) => (
          <div key={i} style={{
            padding: '8px 10px', borderRadius: 8,
            background: s.done ? 'var(--green-soft)' : 'var(--muted)',
            border: '1px solid var(--border)',
            display: 'flex', alignItems: 'center', gap: 7, fontSize: 11.5,
            color: s.done ? 'var(--green)' : 'var(--fg-muted)',
          }}>
            <Icon name={s.done ? 'check-circle-2' : 'circle'} size={12} />
            {s.label}
          </div>
        ))}
      </div>
    </Block>
  );
};

export default ModelTrainingProgress;
